export default __webpack_public_path__ + "static/media/imageUpload.f5d2ee22.svg";